import {
  FETCH_REVENUE_REQUEST,
  FETCH_REVENUE_SUCCESS,
  FETCH_REVENUE_FAILURE,
} from '../constants/revenueConstants';

const initialState = {
  data: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    currentPage: 1,
  },
  revenue: {
    usd: 0,
    yen: 0,
    sgd: 0,
    hkd: 0,
    aud: 0,
    eur: 0,
  },
};

const revenueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REVENUE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REVENUE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.response || [],
        pagination: {
          totalPages: action.payload.pagination?.totalPages || 0,
          totalItems: action.payload.pagination?.totalItems || 0,
          itemsPerPage: action.payload.pagination?.itemsPerPage || 10,
          currentPage: action.payload.pagination?.currentPage || 1,
        },
        revenue: action.payload.revenue || state.revenue,
        error: null,
      };
    case FETCH_REVENUE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
      };
    default:
      return state;
  }
};

export default revenueReducer;